import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  website: null,
};

const userSlice = createSlice({
  name: "website",
  initialState,
  reducers: {
    setWebsite(state, action) {
      state.website = action.payload;
    },
    clearWebsite(state) {
      state.website = null;
    },
  },
});

export const { setWebsite, clearWebsite } = userSlice.actions;
export default userSlice.reducer;
